import React from "react";
import { LineChart } from "lucide-react";

export default function CustomChartPlaceholder() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-slate-400 text-center">
      <LineChart className="w-6 h-6 text-purple-400 mb-2" />
      <p className="text-sm font-medium">🧩 Custom Chart</p>
      <p className="text-xs text-slate-500 mt-2 max-w-xs">
        This space can be used for your own integrated charts — for example, Binance API,
        TradingLite, or M2T internal chart engine.
      </p>
      <button
        onClick={() => alert('Coming soon — M2T internal chart engine')}
        className="mt-3 text-xs bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-md transition"
      >
        Launch Custom Chart
      </button>
    </div>
  );
}
